/* __next_internal_client_entry_do_not_use__ DeferRenderedQuickAddBase auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { QuickAddBase } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddBase";
import { QuickAddTrackingEventsContextProvider } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddTrackingEventsContext/QuickAddTrackingEventsContextProvider";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageNonPrimaryContentDeferRender } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPagePerformanceTrackingWrapper";
export var DeferRenderedQuickAddBase = function(param) {
    var data = param.data;
    useSearchPageNonPrimaryContentDeferRender();
    return /*#__PURE__*/ _jsx(QuickAddTrackingEventsContextProvider, {
        data: data,
        children: /*#__PURE__*/ _jsx(QuickAddBase, {
            data: data
        })
    });
};
